import {
  ActionSchema,
  DynamicBooleanSchema,
  DynamicStringSchema,
} from '@a2ui/web_core/v0_9';
import { createComponentImplementation } from '@a2ui/react/v0_9';
import { defineA2uiComponentSchema } from '../../a2ui-schema';
import { QuoteNote } from './QuoteNote';

interface ResolvedProps {
  readonly title?: string;
  readonly body?: string;
  readonly saved?: boolean;
  readonly saving?: boolean;
  readonly onSave?: () => void;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const schema = defineA2uiComponentSchema({
  title: DynamicStringSchema,
  body: DynamicStringSchema,
  saved: DynamicBooleanSchema,
  // Bound by the BE to `/_inFlight/<note id>` — the surface's in-flight flag,
  // set on dispatch and cleared on both success and failure.
  saving: DynamicBooleanSchema,
  onSave: ActionSchema,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any;

export const QuoteNoteImpl = createComponentImplementation(
  { name: 'QuoteNote', schema },
  // The v0_9 runtime hands us `context.dataContext` (edit sink) and
  // `context.componentModel.id` (this note's own id). The note's editable
  // values live at `/<id>/title` and `/<id>/body` — the BE binds `title`/`body`
  // and the AddNote action to those same paths (both sides derive them from the
  // note id: `note-<optionId>`), so writing edits back to the id-derived paths
  // keeps everything aligned with no extra path props to drift.
  ({
    props,
    context,
  }: {
    props: ResolvedProps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    buildChild: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    context: any;
  }) => {
    const noteId: string = context?.componentModel?.id ?? '';
    const writeAt = (field: 'title' | 'body', value: string) => {
      if (noteId) context.dataContext.set(`/${noteId}/${field}`, value);
    };
    return (
      <QuoteNote
        title={props.title}
        body={props.body}
        saved={props.saved}
        saving={props.saving}
        onTitleChange={(v) => writeAt('title', v)}
        onBodyChange={(v) => writeAt('body', v)}
        onSave={props.onSave}
      />
    );
  }
);
